import { Feature } from '@getstep/proto/feature'
import { useLocalStorage } from '@lib/hooks/useLocalStorage'

import styles from './TestFeatureFlagsModal.module.scss'
import { TestModal } from './TestModal'

// Storage key for test feature flags that should be enabled after login
const TEST_FEATURE_FLAGS_STORAGE_KEY = 'storage.TestFeatureFlagsToEnable'

// List of feature flags available for dev testing
const TEST_FEATURES = [
    {
        feature: Feature.EXTERNAL_BANK_REQUIREMENT,
        label: 'External Bank Requirement',
        description: 'Require external bank account linking',
    },
]

interface TestFeatureFlagsModalProps {
    isOpen: boolean
    onClose: () => void
    onFlagsChange?: (flags: Feature[]) => void
}

export const TestFeatureFlagsModal = ({
    isOpen,
    onClose,
    onFlagsChange,
}: TestFeatureFlagsModalProps) => {
    const [selectedFlags, setSelectedFlags] = useLocalStorage<Feature[]>(
        TEST_FEATURE_FLAGS_STORAGE_KEY,
        [],
    )

    const handleToggle = (feature: Feature) => {
        const newFlags = selectedFlags.includes(feature)
            ? selectedFlags.filter((f) => f !== feature)
            : [...selectedFlags, feature]

        setSelectedFlags(newFlags)

        // Notify parent component about the change
        onFlagsChange?.(newFlags)
    }

    return (
        <TestModal
            isOpen={isOpen}
            onClose={onClose}
            title='Test Feature Flags'
            description='Select feature flags to enable after login. Flags will be applied on the server after successful verification.'
            footer={
                <button className={styles.closeButton} onClick={onClose}>
                    Done
                </button>
            }
        >
            <div className={styles.flagsList}>
                {TEST_FEATURES.map(({ feature, label, description }) => (
                    <label key={feature} className={styles.flagItem}>
                        <input
                            type='checkbox'
                            checked={selectedFlags.includes(feature)}
                            onChange={() => handleToggle(feature)}
                            className={styles.checkbox}
                        />
                        <div className={styles.flagContent}>
                            <div className={styles.flagLabel}>{label}</div>
                            <div className={styles.flagDescription}>
                                {description}
                            </div>
                        </div>
                    </label>
                ))}
            </div>
        </TestModal>
    )
}
